import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.scss";
import App from "./app";
import Gleap from "gleap";

Gleap.initialize("eX9evP8uxUb3Tc7rzSdsXGv9pk4aXvkT");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
